import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { PageShell } from './components/PageShell.js';
import { FormSkeleton } from './components/Skeleton.js';
import { FALLBACK_THEME } from './lib/theme.js';
import { EventHome } from './pages/EventHome.js';
import { EventLayout } from './pages/EventLayout.js';
import { NotFoundPage } from './pages/NotFoundPage.js';
import { SessionsPage } from './pages/SessionsPage.js';
import { SpeakersPage } from './pages/SpeakersPage.js';

// The whole attendee surface.
//
// `/f` takes its token from the query string rather than the path, because the
// link is minted into an email and Hosting rewrites the path — see the `/f**`
// header note in scripts/deploy/firebase.sh, which is why the glob is `**`.
//
// The form page is split out because RJSF, ajv and lodash are roughly two
// thirds of the bundle and *only* the form needs them. An attendee opening the
// schedule on conference wifi should not download a form engine to read it.
const FormPage = lazy(() => import('./pages/FormPage.js').then((m) => ({ default: m.FormPage })));

export function App() {
  return (
    <Routes>
      <Route
        path="/f"
        element={
          <Suspense
            fallback={
              <PageShell theme={FALLBACK_THEME} width="reading">
                <FormSkeleton />
              </PageShell>
            }
          >
            <FormPage />
          </Suspense>
        }
      />
      <Route path="/e/:slug" element={<EventLayout />}>
        <Route index element={<EventHome />} />
        <Route path="sessions" element={<SessionsPage />} />
        <Route path="speakers" element={<SpeakersPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
